globalThis.backoffice = globalThis.backoffice || {};

backoffice.TwilioServices = (function()
{
    var defaults = {
        loader: null,
        selectors: {
            successOverlay: '.overlay-success',
            errorOverlay: '.overlay-error'
        }
    }

    function TwilioServices($html, options) {
        this.$html = $html;
        this.config = $.extend({}, defaults, options);
        this.init();
    }

    TwilioServices.prototype = {
        init: function() {
            if(this.$html) {
                this.initTwilioSendSMS();
            }
        },
        initTwilioSendSMS: function() {
            var self = this;

            this.$html.find('button.send-sms').on('click', function() {
                var $button = $(this);
                var $buttonText = $button.find('.button-text');
                var sms_sender = $('input[name="sms-sender-id"]').val();
                var sms_recipient = $('select[name="sms-recipient-id"]').val();
                var sms_content = $('textarea[name="sms-content"]').val();
                var sms_model_id = $('select[name="sms-model-id"]').val();


                $button.prop('disabled', true).data('original-text', $buttonText.text());
                $buttonText.text('Envoi...');

                $.post('/ajax/twilio/send_sms', {
                    sender_id: sms_sender,
                    recipient_id: sms_recipient,
                    text_message_model_id: sms_model_id,
                    message: sms_content,
                }, function(data) {
                    $button.prop('disabled', false)
                    $buttonText.text($button.data('original-text'));

                    if(data.response) {
                        self.displaySuccessOverlay("SMS envoyé !");
                    } else {
                        alert("Erreur lors de l'envoi du SMS")
                    }
                    setTimeout(function() {
                        self.$html.modal('hide');
                    }, 2000);
                });
            });

            this.$html.on('change', 'select[name=sms-model-id]', function() {
                var $select = $(this);
                var sms_sender = $('input[name="sms-sender-id"]').val();
                var sms_recipient = $('select[name="sms-recipient-id"]').val();
                var url = '/ajax/interactions_manager/text_message_models/' + $select.val() + '/message_content';
                var $textarea = $('textarea[name="sms-content"]');

                if($select.val()) {
                    $.get(url, {
                        sender_id: sms_sender,
                        recipient_id: sms_recipient
                    }, function(data) {
                        if(data.message) {
                            $textarea.val(data.message);
                            autosize.update($textarea);
                        }
                    });
                } else {
                    $textarea.val('');
                    autosize.update($textarea);
                }
            });
        },
        displaySuccessOverlay: function(message) {
            var $message = this.$html.find('.success-message');

            if(message) {
                $message.text(message);
            }

            this.$html.find(this.config.selectors.successOverlay).fadeIn('fast');
        },
        displayErrorOverlay: function(message) {
            this.$html.find(this.config.selectors.errorOverlay)
                .find('.error-message').text(message).end()
                .fadeIn('fast');
        }
    }

    return TwilioServices;
})();
